import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '../../translate';
import { MaterialModule } from '../../shared/material.module';
import { MeasurementPointsAdminComponent } from './admin-component/measurement-points-admin.component';
//import { MeasurementPointsDetailComponent } from './measurement-points-detail/measurement-points-detail.component';
import { CreateMeasurementPointsComponentComponent } from './create-measurement-points-component/create-measurement-points-component.component';
import { EditMeasurementPointsComponentComponent } from './edit-measurement-points-component/edit-measurement-points-component.component';
import { InflectionCalMethodComponent } from './edit-measurement-points-component/inflection-cal-method/inflection-cal-method.component';
import { SteppedCalMethodComponent } from './edit-measurement-points-component/stepped-cal-method/stepped-cal-method.component';
import { PloynomialCalMethodComponent } from './edit-measurement-points-component/ploynomial-cal-method/ploynomial-cal-method.component';
import { JdCalMethodComponent } from './edit-measurement-points-component/jd-cal-method/jd-cal-method.component';
import { LinearCalMethodComponent } from './edit-measurement-points-component/linear-cal-method/linear-cal-method.component';
import { MeasurementPonitsService } from './services/measurement-points-service';
import { FormsModule, ReactiveFormsModule } from '../../../../node_modules/@angular/forms';
import { CalculationMethodFormsComponent } from './edit-measurement-points-component/calculation-method-forms/calculation-method-forms.component';
import { AppModule } from '../../../app/app.module';
import { AddWsreSubcomponentComponent } from './add-wsre-subcomponent/add-wsre-subcomponent.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
        MaterialModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        MeasurementPointsAdminComponent,
        //MeasurementPointsDetailComponent,
        EditMeasurementPointsComponentComponent,
        CreateMeasurementPointsComponentComponent,
        InflectionCalMethodComponent,
        SteppedCalMethodComponent,
        PloynomialCalMethodComponent,
        LinearCalMethodComponent,
        JdCalMethodComponent,
        CalculationMethodFormsComponent,
        AddWsreSubcomponentComponent,
    ],
    providers: [
        MeasurementPonitsService
    ]
})
export class MeasurementPointsAdminModule { }
